//angular
import { Component, Input, Output, OnInit, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
//app animations
import { AppAnimations } from 'src/app/_shared/animations';
//app data
import { AvalaraSettingKeyValues, ChargeModelValues, collectionOfChargeModel, collectionOfTaxClass, collectionOfTaxClassAux, DEFAULT_VALUE_CUSTOM_TAX, PriceUnitValues, TaxClassValues, VisibleState } from 'src/app/app.data';
//app interfaces
import { ChargeTier } from 'src/app/_shared/interfaces/subscription.interface';
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
//app models
import { CompanyCurrency } from 'src/app/_shared/models/company.model';
import { RestResponse, CompanyIntegrationModel } from 'src/app/_shared/models';
//others
import { DataSharingService, UtilsService } from 'src/app/_core/services';
import { ValidatorService } from 'src/app/_shared/validators/validator.service';
import { SharedIntegrationService } from 'src/app/_core/services/api/shared-integration.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '' },
  selector: 'form-charge-price',
  templateUrl: './charge-price.component.html',
  styleUrls:['./charge-price.component.scss']
})

export class FormChargePriceComponent implements OnInit, AfterViewInit, OnDestroy {
  cleaveNumDecimalOptions;
  cleaveNumIntegerOptions;
  collectionOfPriceModel: Array<DropDown> = collectionOfChargeModel;
  collectionOfRatePlanChargeTiers: Array<any> = [];
  collectionOfTaxClass: Array<DropDown> = collectionOfTaxClassAux;
  currencyDefault: CompanyCurrency;
  currencyDefaultId: number;
  currencyIso3: string;
  currencySymbol: string;
  form: FormGroup;
  isTierPrice = false;
  selectedChargeModel: ChargeModelValues = ChargeModelValues.perUnitPricing;
  statusForCurrencyBase: boolean = false;
  // ratePlanCharge: NewProductRatePlanCharge;
  ratePlanCharge: any;
  isSubscription: boolean = false;
  isEditOnCreatedSubscription: boolean = false;
  initialPrice: string;
  initialQuantity: number;
  hasExternalRatePlanCharge: boolean = false;
  companyIntegrationId: number;
  integrationConfig: CompanyIntegrationModel = new CompanyIntegrationModel();
  collectionOfIntegrationSettings: Array<any> = [];
  private subs = new Unsubscriber();

  @Input() _data: any;
  @Input() _chargeModel = ChargeModelValues;
  @Input() _visibleState = VisibleState;

  @Output() _emitBodyParams: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitFormErrors: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _fb: FormBuilder,
    public _meta: MetaService,
    private _shareData: DataSharingService,
    private sharedIntegrationService: SharedIntegrationService,
    private _validatorService: ValidatorService,
    private utils: UtilsService
  ) {
    this.subs.addSub = this._shareData.getSettingsVariables().subscribe(([decimalPlaces, decimalToken, thousandsToken]) => {
      this.cleaveNumDecimalOptions = {
        numeral: true,
        numeralPositiveOnly: true,
        stripLeadingZeroes: false,
        numeralDecimalScale: decimalPlaces,
        delimiter: thousandsToken,
        numeralDecimalMark: decimalToken
      };

      this.cleaveNumIntegerOptions = {
        numeral: true,
        numeralPositiveOnly: true,
        stripLeadingZeroes: false,
        numeralDecimalScale: 0,
        delimiter: thousandsToken,
        numeralDecimalMark: decimalToken
      };
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  refreshQuantityOnUsageBased() {
    if(this._data?.usageBased) {
      this.form.get('allowChangeQuantity').setValue(false);
      this.form.get('allowChangeQuantity').disable();

      this.form.get('useSaleChannelData').setValue(false);
      this.form.get('useSaleChannelData').disable();

      if(!this._data.isEdit){
        this.form.get('quantity')?.setValue(0);
      }
      this.form.get('quantity')?.disable();
    } else {
      this.form.get('allowChangeQuantity').enable();
      this.form.get('useSaleChannelData').enable();
      this.form.get('quantity')?.enable();
    }
  }

  manageQuantity() {
    this.form.addControl('quantity', new FormControl(this.ratePlanCharge?.quantity !== null ? this.ratePlanCharge?.quantity : 1, [Validators.required, this._validatorService.positiveDecimalNumberIncludeZero]));

    if (this.ratePlanCharge?.id) {
      this.initialQuantity = this.form.get('quantity').value;
      if (this.form.get('useSaleChannelData').value) {
        this.form.get('quantity').disable();
      }
    }
  }

  getSubscriptionPath() {
    // created subscription
    this.isSubscription = true;
    // adds quantity input
    this.form.addControl('quantity', new FormControl(this.ratePlanCharge?.quantity !== null ? this.ratePlanCharge?.quantity : 1, [Validators.required, this._validatorService.positiveDecimalNumberIncludeZero]));
    // edit
    if (this.ratePlanCharge?.id) {
      this.hasExternalRatePlanCharge = this.ratePlanCharge?.externalRatePlanCharges?.length > 0;
      // tier price
      this.initialPrice = this.form.get('price').value;
      this.initialQuantity = this.form.get('quantity').value;

      if (this.hasExternalRatePlanCharge && this.form.get('useSaleChannelData').value) {
        this.form.get('price').setValue(this.ratePlanCharge?.price);
        this.form.get('chargeModel').disable();
        this.form.get('price').disable();
        this.form.get('quantity').disable();
      }

      this.isEditOnCreatedSubscription = true;
    }
  }

  ngOnInit(): void {
    this.subs.addSub = this._shareData.getCompanySettingsTaxSource().subscribe((res) => {
      this.companyIntegrationId = res.tax;
      if(this.companyIntegrationId && this.companyIntegrationId !== 0) {
        this.subs.addSub = this.sharedIntegrationService.getCompanyIntegraionSettingsByIntegrationId(this.companyIntegrationId)
        .subscribe(
          (res: RestResponse) => {
            this.collectionOfTaxClass = collectionOfTaxClass;

            this.integrationConfig = new CompanyIntegrationModel().deserialize(res.data);

            this.collectionOfIntegrationSettings = this.integrationConfig.integrationSetting;

            this.ratePlanCharge = this._data.ratePlanCharge;

            if (this._data.isSubscription) {
              this.currencySymbol = this._data.subscriptionCompanyCurrency?.currency?.symbol;
              this.currencyIso3 = this._data.subscriptionCompanyCurrency?.currency?.iso3;
              this.currencyDefault = this._data.subscriptionCompanyCurrency;
              this.statusForCurrencyBase = true;

              this.setUpForm();
              this.getSubscriptionPath();
            } else {
              //Subscribe to company currency base
              this.subs.addSub =  this._shareData.currentCompanySettingsCurrencyBaseSource.subscribe(data => {
                let companyCurrencyBase = data.currencyBase;
                this.currencySymbol = companyCurrencyBase?.currency?.symbol;
                this.currencyIso3 = companyCurrencyBase?.currency?.iso3;
                this.currencyDefault = companyCurrencyBase;
                this.statusForCurrencyBase = true;

                this.setUpForm();
                this.manageQuantity();
              });
            }

          },
          (err: RestResponse) => {
            this._meta.showNotification(err);
          }
        );
      } else {
        //Subscribe to company currency base
        this.ratePlanCharge = this._data.ratePlanCharge;
        this.subs.addSub =  this._shareData.currentCompanySettingsCurrencyBaseSource.subscribe(data => {
          let companyCurrencyBase = data.currencyBase;
          this.currencySymbol = companyCurrencyBase?.currency?.symbol;
          this.currencyIso3 = companyCurrencyBase?.currency?.iso3;
          this.currencyDefault = companyCurrencyBase;
          this.statusForCurrencyBase = true;
          this.setUpForm();
          this.manageQuantity();
        });

        if(this._data.isSubscription) {
          this.getSubscriptionPath();
        }
      }
    });
  }

  ngAfterViewInit() {
    let previousValid = this.form?.valid;
    this.form?.valueChanges.subscribe(() => {
      if (this.form?.valid !== previousValid) {
        this._emitFormErrors.emit(false);
      }
    });
  }

  onChangeChargeModel(_event: any) {
    let _value = _event.value
    const chargeTier = <FormArray>this.form.get('chargeTier');
    chargeTier.clear();
    chargeTier.markAsPristine();
    chargeTier.markAsUntouched();
    this.collectionOfRatePlanChargeTiers = [];
    this.selectedChargeModel = _value;

    switch (this.selectedChargeModel) {
      case ChargeModelValues.flatFeePricing:
        chargeTier.push(this.setRatePlanChargeTier(1, 1, PriceUnitValues.flatFee, this.ratePlanCharge?.chargeTier?.length > 0 ? this.ratePlanCharge?.chargeTier[0]?.price : ''));
        chargeTier.controls[0].get('startingUnit').disable();
        chargeTier.controls[0].get('endingUnit').disable();
        this.addPriceInput();
        this.isTierPrice = false;
        break;
      case ChargeModelValues.perUnitPricing:
        chargeTier.push(this.setRatePlanChargeTier(1, 1, PriceUnitValues.perUnit, this.ratePlanCharge?.chargeTier?.length > 0 ? this.ratePlanCharge?.chargeTier[0]?.price : ''));
        chargeTier.controls[0].get('startingUnit').disable();
        chargeTier.controls[0].get('endingUnit').disable();
        this.addPriceInput();
        this.isTierPrice = false;
        break;
      case ChargeModelValues.tieredPricing:
        chargeTier.push(this.setRatePlanChargeTier(1, null, PriceUnitValues.perUnit));
        chargeTier.controls[0].get('startingUnit').enable();
        chargeTier.controls[0].get('endingUnit').enable();
        this.removePriceInput();
        this.isTierPrice = true;
        break;
      case ChargeModelValues.volumePricing:
        chargeTier.push(this.setRatePlanChargeTier(1, null, PriceUnitValues.perUnit));
        chargeTier.controls[0].get('startingUnit').enable();
        chargeTier.controls[0].get('endingUnit').enable();
        this.removePriceInput();
        this.isTierPrice = true;
        break;
    }
    this.collectionOfRatePlanChargeTiers = chargeTier.value;
  }

  onChangeTaxClass(_event) {
    let _value: TaxClassValues = _event.value
    this.setTaxCode(_value);
  }

  onClickDeleteChargeTier(_index: number){
    // remove charge tier from array
    this.collectionOfRatePlanChargeTiers.splice(_index, 1);
    // remove charge tier from form
    const chargeTier = <FormArray>this.form.get('chargeTier');
    chargeTier.removeAt(_index);
    // set endingUnit to unlimited on the last charge tier.
    const lastIndex = Number(chargeTier.length) - 1;
    const lastChargeTierItem = <FormControl>chargeTier.at(lastIndex);
    lastChargeTierItem.get('endingUnit').setValue(null);
  }

  onFocusOutEndingQty(_index: number, _event: any) {
    let _value = _event.target.value;
    if (_value !== '') {
      if (typeof this.collectionOfRatePlanChargeTiers[(_index + 1)] === 'undefined') {
        const  chargeTier = <FormArray>this.form.get('chargeTier');
        chargeTier.push(this.setRatePlanChargeTier(Number(_value) + 1,
          null, (this.selectedChargeModel === ChargeModelValues.tieredPricing ? PriceUnitValues.flatFee : PriceUnitValues.perUnit)));
        this.collectionOfRatePlanChargeTiers = chargeTier.value;
      }
    }
  }

  setBodyParams(): void {
    let bodyParams: any = {
      chargeModel: this.form.get('chargeModel').value,
      chargeTier: this.setChargeTier(),
      taxClass: this.form.get('taxClass').value,
      taxCode: this.form.get('taxCode').value,
      taxable: this.form.get('taxable').value,
      allowChangeQuantity: this.form.get('allowChangeQuantity').value,
      priceType: this.form.get('priceType').value,
      quantity: this.utils.convertToNumber(this.form.get('quantity').value),
    };
    if (this.isSubscription) {
      // subscription
      if (this.hasExternalRatePlanCharge) {
        bodyParams.useSaleChannelData = this.form.get('useSaleChannelData').value;
      }
    } else {
      // product
      bodyParams.useSaleChannelData = this.form.get('useSaleChannelData').value;
    }

    let chargeTier = <FormArray>this.form.get('chargeTier');
    if (this.isTierPrice) {
      chargeTier.value.forEach(item => {
        item.price = this.utils.convertToNumber(item.price);
        if(this._data.inlineEdit) {
          item.price  = this.utils.formatDecimalNumberToReceive(item.price);
        }
      });
    } else {
      chargeTier.value[0].price = this.utils.convertToNumber(this.form.get('price').value);
      if(this._data.inlineEdit) {
        chargeTier.value[0].price = this.utils.formatDecimalNumberToReceive(chargeTier.value[0].price);
      }
      chargeTier.value[0].startingUnit = '1';
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      this._emitFormErrors.emit(true);
      return;
    }

    this._emitBodyParams.emit(bodyParams);
  }

  setChargeModel(_chargeModel: ChargeModelValues, _chargeTier: ChargeTier[]) {
    const chargeTier = <FormArray>this.form.get('chargeTier');
    chargeTier.clear();
    this.collectionOfRatePlanChargeTiers = [];
    this.selectedChargeModel = _chargeModel;

    this.collectionOfRatePlanChargeTiers = chargeTier.value;
    if (_chargeModel === ChargeModelValues.tieredPricing ||
      _chargeModel === ChargeModelValues.volumePricing) {
      this.removePriceInput();
      this.isTierPrice = true;
      this.selectedChargeModel = _chargeModel;
      _chargeTier.forEach( item => {
        const chargeTier = <FormArray>this.form.get('chargeTier');
        chargeTier.push(this.setRatePlanChargeTier(parseInt(item.startingUnit, 10), item.endingUnit,
        PriceUnitValues.perUnit, item.price));
        this.collectionOfRatePlanChargeTiers = chargeTier.value;
      });
    } else {
      this.addPriceInput();
      const price = this.form.get('price').value;
      this.isTierPrice = false;
      const chargeTier = <FormArray>this.form.get('chargeTier');
      chargeTier.push(this.setRatePlanChargeTier(1, 1, PriceUnitValues.flatFee, price));
      this.collectionOfRatePlanChargeTiers = chargeTier.value;
      chargeTier.controls[0].get('startingUnit').disable();
      chargeTier.controls[0].get('endingUnit').disable();
    }
  }

  setChargeTier() {
    const chargeTier = <FormArray>this.form.controls.chargeTier;
    return [...chargeTier.value];
  }

  setRatePlanChargeTier(
    _startingUnit: number = null,
    _endingUnit: any = null,
    _priceFormat: PriceUnitValues = PriceUnitValues.perUnit,
    _price?: any
  ) {
    return this._fb.group({
      startingUnit: [(_startingUnit == null ? '1' : String(_startingUnit)), [this._validatorService.emptySpace, this._validatorService.positiveDecimalNumberExcludeZero]],
      endingUnit: [(_endingUnit == null ? null : String(_endingUnit)), [this._validatorService.emptySpace]],
      currency: this.currencyIso3,
      price: [_price ? (this.isTierPrice && this._data.inlineEdit ? this.utils.formatDecimalNumberToReceive(_price) : _price) : '', this.isTierPrice ? [Validators.required, this._validatorService.positiveDecimalNumberIncludeZero] : [this._validatorService.positiveDecimalNumberIncludeZero]],
      priceFormat: _priceFormat,
    });
  }

  getIntegrationSettingTaxCodeByKeyName(keyName) {
    return this.collectionOfIntegrationSettings.find(integrationSetting => integrationSetting.keyName === keyName)?.value;
  }

  getIntegrationSettingByValue(value) {
    return this.collectionOfIntegrationSettings.find(integrationSetting => integrationSetting.value === value);
  }

  setTaxCode(keyName: TaxClassValues) {
    switch (keyName) {
      case TaxClassValues.nonTaxable:
        this.form.get('taxCode').setValue(AvalaraSettingKeyValues.code_non_taxable);
        this.form.get('taxCode').disable();
        this.form.get('taxable').setValue(false);
      break;
      case TaxClassValues.custom:
        if (this.ratePlanCharge?.taxClass === TaxClassValues.custom) {
          this.form.get('taxCode').setValue(this.ratePlanCharge?.taxCode || DEFAULT_VALUE_CUSTOM_TAX);
        } else {
          this.form.get('taxCode').setValue(DEFAULT_VALUE_CUSTOM_TAX);
        }
        this.form.get('taxCode').enable();
        this.form.get('taxable').setValue(true);
      break;
      case TaxClassValues.manualTax:
        this.form.get('taxCode').setValue('');
        this.form.get('taxCode').enable();
        this.form.get('taxable').setValue(true);
      break;

      default:
        let integrationSettingTaxCode = this.getIntegrationSettingTaxCodeByKeyName(keyName);

        this.form.get('taxCode').setValue(integrationSettingTaxCode);
        this.form.get('taxCode').disable();
        this.form.get('taxable').setValue(true);
    }
  }

  addPriceInput() {
    if (!this.form.get('price')) {
      this.form.addControl('price', new FormControl(this.ratePlanCharge?.chargeTier?.length > 0 ? this._data.inlineEdit ? this.utils.formatDecimalNumberToReceive(this.ratePlanCharge?.chargeTier[0]?.price) : this.ratePlanCharge?.chargeTier[0]?.price : '', [Validators.required, this._validatorService.positiveDecimalNumberIncludeZero]));
      this.form.updateValueAndValidity();
    }
  }

  removePriceInput() {
    if (this.form.get('price')) {
      this.form.removeControl('price');
      this.form.updateValueAndValidity();
    }
  }

  onChangeUseSaleChannelDataCheckbox() {
    if (this.form.get('useSaleChannelData').value)
    {
      this.form.get('price').setValue(this.ratePlanCharge?.price);

      if (this.form.get('quantity').value !== this.initialQuantity) {
        this.form.get('quantity').setValue(this.initialQuantity);
      }
      this.form.get('chargeModel').disable();
      this.form.get('price').disable();
      this.form.get('quantity').disable();
    } else {
      this.form.get('price').setValue(this.initialPrice);
      this.form.get('chargeModel').enable();
      this.form.get('price').enable();
      this.form.get('quantity').enable();
    }
  }

  setUpForm() {
    this.form = this._fb.group({
      chargeModel: [this.ratePlanCharge?.chargeModel ? this.ratePlanCharge?.chargeModel : ChargeModelValues.perUnitPricing, [Validators.required]],
      chargeTier: new FormArray([]),
      taxClass: [this.ratePlanCharge?.taxClass ? this.ratePlanCharge?.taxClass : TaxClassValues.nonTaxable, [Validators.required]],
      taxCode: ['', [Validators.required]],
      taxable: this.ratePlanCharge?.taxable ? this.ratePlanCharge?.taxable : false,
      useSaleChannelData: this.ratePlanCharge?.useSaleChannelData ? this.ratePlanCharge?.useSaleChannelData : false,
      allowChangeQuantity: this.ratePlanCharge?.allowChangeQuantity ? this.ratePlanCharge?.allowChangeQuantity : false,
      priceType: this.ratePlanCharge?.priceType ? this.ratePlanCharge?.priceType : 'currency',
    });

    this.setChargeModel(ChargeModelValues[this.form.get('chargeModel').value], this.ratePlanCharge?.chargeTier);

    // inlineEdit (memory) works on new product and new product rate plan
    if (!this.isTierPrice && this.form.get('price').value && this._data.inlineEdit) {
      let price = this.ratePlanCharge?.chargeTier[0]?.price;
      this.form.get('price').setValue(this.utils.formatDecimalNumberToReceive(price));
    }

    if (!this.ratePlanCharge?.taxCode) {
      this.setTaxCode(TaxClassValues.nonTaxable);
    } else {
      let integrationSetting = this.getIntegrationSettingByValue(this.ratePlanCharge?.taxCode);
      if (this.ratePlanCharge?.taxCode !== AvalaraSettingKeyValues.code_non_taxable && !integrationSetting) {
        this.form.get('taxCode').setValue(this.ratePlanCharge?.taxCode);
        this.form.get('taxClass').setValue(this.ratePlanCharge?.taxClass == TaxClassValues.manualTax? TaxClassValues.manualTax: TaxClassValues.custom);
      } else {
        if (this.form.get('taxClass').value) {
          this.setTaxCode(TaxClassValues[this.form.get('taxClass').value]);
        }
      }
    }
  }
}
